import styled from 'styled-components';

import { CredusButton, color, CredusInputPassword, CredusAlert } from 'ui';
import useAccountChangePassword from './hooks/useAccountChangePassword';
import { LoaderWhite } from '../../assets/images/svgs';

const ChangePassword = () => {
  const { formik, apiError, isLoading, handleCloseAlert } =
    useAccountChangePassword();
  return (
    <SubContainer>
      <form onSubmit={formik.handleSubmit}>
        {apiError && (
          <AlertWrapper>
            <CredusAlert
              type="error"
              message={apiError}
              show={!!apiError}
              onCancel={handleCloseAlert}
            />
          </AlertWrapper>
        )}
        <FormDiv>
          <div>
            <CredusInputPassword
              label="Old Password"
              name="oldPassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.oldPassword}
              error={
                formik.touched.oldPassword ? formik.errors.oldPassword : ''
              }
            />
          </div>
          <div>
            <CredusInputPassword
              label="New Password"
              name="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              error={formik.touched.password ? formik.errors.password : ''}
            />
          </div>
          <div>
            <CredusInputPassword
              label="Confirm New Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              name="confirmPassword"
              value={formik.values.confirmPassword}
              error={
                formik.touched.confirmPassword
                  ? formik.errors.confirmPassword
                  : ''
              }
            />
          </div>
        </FormDiv>
        <BtnDiv>
          <div>
            <CredusButton type="submit" variant="primary" disabled={isLoading}>
              {isLoading ? (
                <LoaderWhite style={{ width: 95, height: 20 }} />
              ) : (
                'Save changes'
              )}
            </CredusButton>
          </div>
        </BtnDiv>
      </form>
    </SubContainer>
  );
};

export default ChangePassword;

const SubContainer = styled.div`
  background: ${color.white};
  width: 40%;
  margin: 1.5rem auto 0rem;
`;

const FormDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2.5rem;
  margin-top: 1.25rem;
`;

const BtnDiv = styled.div`
  margin-top: 3.2rem;
`;

export const AlertWrapper = styled.div`
  margin: 0px 0px 20px;
`;
